import {authenticate} from "../services/authentication/Authentication";
import { history,deleteCookie, getCookie } from "../services/helper/Helper";
import { showLoader,hideLoader, notification,showHideModal,hideShowPassword,resetModalValues,showHideNotificationModal } from "./uiAction";
import { errorMessage, LOGIN_SUCCESS, LOGIN_FAILED, LOGOUT,RESET_DOCKET_DATA,EMAIL_SENT } from "../config";
import {addUser,isUserexists,caseidExists,sendForgotPasswordLink,resetOldPassword,getCurrentUserData,getUserData,updateUserData,logoutUser} from "../services/http-services/HttpServices";
import { validateAndCheckErrors } from "../services/helper/YupValidationHelper";
import { actions } from "react-redux-form";


/* Name : Neha
   Description : Function is used to fetch the login details and redirect the user to the dashboard or find case page based on the user type.
*/
export function login(data,redirectLink,params) {
  return function(dispatch) {
    dispatch(showLoader())
		var request = {...data,params:params};
    return authenticate(request)
      .then(response => {
		  var notificationFlag = response.flag;
        if(response.authentication){
			return caseidExists()
			.then(response => {
				if(redirectLink!='' && redirectLink!=undefined && redirectLink!='/publicAccess/docketAccess' && redirectLink!='/')
				{
					history.push(redirectLink);
					dispatch(loginSuccess({}))
					dispatch(hideLoader())
				}else{
					if(response.result)
					{
						history.push('/publicAccess/dashboard/open');
						dispatch(loginSuccess({}))
						dispatch(hideLoader())
					}else{
						
						history.push('/publicAccess/docketAccess');
						dispatch(loginSuccess({}))
						dispatch(hideLoader())
						dispatch(actions.change("myDocketform.e_services",'0'))
					}
					if(notificationFlag){
						dispatch(showHideNotificationModal(true))
					}
				}
			})
          
        }else{
          dispatch(loginFailed(response))
        }
        dispatch(hideLoader())
        //dispatch stop loader
      })
  }
}
export function logout() {
  return function(dispatch) {
    dispatch(showLoader())
	return logoutUser()
		.then(response => {
			dispatch(hideLoader())
			if(response == 1 || response == '1')
			{
				deleteCookie(btoa("publicAccess"));
				deleteCookie(btoa("TAWAJ"));
				history.push('/login');
				dispatch(userLogout())
				dispatch({type:RESET_DOCKET_DATA})
				
				// if(deleteCookie(btoa("publicAccess"))){
				//   history.push('/login');
				//   dispatch(userLogout())
				//   dispatch({type:RESET_DOCKET_DATA})
				// }
				// else{
				//   dispatch(notification(errorMessage.tryAgain))
				// }
			}
		})
    
		setTimeout(()=>{dispatch(hideLoader())},100)
  }
}
/* dispatching to reducer start */
function loginSuccess(user) {
	return {
    type: LOGIN_SUCCESS,
    user
  }
}
function loginFailed(user) {
	return {
    type: LOGIN_FAILED,
	user
  }
}
function userLogout() {
	return {
    type: LOGOUT
  }
}

/* dispatching to reducer end */

/* Name : Neha
   Description : Function is used to validate the user while creating account.
*/
export function validateUser(data,userSchema) {
	
  
  return (dispatch,getState) => {
		let {createAccount} = getState();
		//console.log(createAccount);
		validateAndCheckErrors(dispatch,userSchema,createAccount).then(flag=>{
			
			 if(flag) {
				  //console.log(data.bar_no);
				 if((data.user_type=='1' || data.user_type=='0') && (data.bar_no=='' || data.bar_no==undefined || data.bar_no.trim()==''))
					
					{
						let message = (data.user_type=='1') ? 'Please enter your bar number.' : 'Please enter your badge number.';
						dispatch(notification(message));
						// setTimeout(()=>dispatch(notification),0)  
					}else{
						dispatch(showLoader())
						return isUserexists(data)
						.then(response => {
							dispatch(hideLoader())
							if(response.result)
							{
								dispatch(notification("An account with this email already exists."));
								// setTimeout(()=>dispatch(notification), 0)  
							}else{
								dispatch(showHideModal(true))
							}
						})
					}
	  
	  // let isValidFlag = true;
	  // let result={};
	  // userSchema.validate(data, { abortEarly: false }).catch(errorsList => {
		  // let errors = {};
		  // for (let _i = 0, _a = errorsList.inner; _i < _a.length; _i++) {
			// let err = _a[_i];
			// if (!errors[err.path]) {
				// errors = setIn(errors, err.path, err.message);
			// }
		  // }
      	// result.errors=errors;
	  	  // validateForm(dispatch,result);
		// });
		
	  
		// userSchema.isValid(data).then(function(valid) {
			// isValidFlag = valid;
			// result.isValid=valid;
			
		// if(!isValidFlag){
		// validateForm(dispatch,result);
	   // setTimeout(()=>dispatch(notification),0)  
	 // }else{
		 
		 
		}
	})
     
     }
  }
/* 
	Name : Neha
	Description : Function is used to add the user in the database.
*/
  export function CreateUser(data,params) {
		return async function(dispatch) {
			dispatch(showHideModal(false))
			dispatch(showLoader())
			let user_type = await getCurrentUserData(); 
			//user_type = user_type.user_type;
			user_type = (user_type) ? user_type.user_type : data.user_type;
			//console.log(user_type, 7900);

			var request = {...data,params:params};
			return addUser(request)
				.then(response => {
					// if(response.result=='true')
					// {
						
						// return authenticate(data)
						// .then(response => {
							if(response.authentication){
								//let value=getCookie(btoa("publicAccess"));
								//let user_type = JSON.parse(atob(value)).user_type;
								
								if(user_type=='2')
								{
									history.push('/publicAccess/docketAccess');
									dispatch(loginSuccess({}))
									dispatch(hideLoader())
								}else{
									return caseidExists()
										.then(response => {
											if(response.result)
											{
												history.push('/publicAccess/dashboard/open');
												dispatch(loginSuccess({}))
												// dispatch(hideLoader())
											}else{
												history.push('/publicAccess/docketAccess');
												dispatch(loginSuccess({}))
												// dispatch(hideLoader())
											}
											dispatch(hideLoader())
										})
									}
							}else{
								dispatch(loginFailed())
								dispatch(hideLoader())
							}
						// })
					// }
					
				})
		}
  }
  /* Name : Neha Agrawal
	Description : Function is used to send the email to the user to reset their password.
	*/
  export function ForgotPassword(data,validateSchema)
  {
	  return (dispatch,getState) => {
		  dispatch(showLoader())
		let {forgotPassword} = getState();
		validateAndCheckErrors(dispatch,validateSchema,forgotPassword).then(flag=>{
			if(flag)
			{
				return sendForgotPasswordLink(data).then(response => {
					dispatch(hideLoader())
					if(response.result)
							{
								history.push('/emailSent');
								dispatch({type: EMAIL_SENT,
								emailId:data.email});
							}else{
								dispatch(notification("An account with this email does not exists.")); 
							}
				})
			}
			dispatch(hideLoader())
		})
	  }
  }
   /* Name : Neha Agrawal
	Description : Function is used to reset user password.
	*/
  export function resetUserPassword(validateSchema,userId)
  {
	return (dispatch,getState) => {
		dispatch(showLoader())
		//console.log(userId);
		let {resetPassword} = getState();
		validateAndCheckErrors(dispatch,validateSchema,resetPassword).then(flag=>{
			if(flag)
			{
				var data = JSON.stringify({...resetPassword,userId:userId});
				 return resetOldPassword(data).then(response => {
					dispatch(hideLoader())
					if(response.status=='1')
					{
						history.push('/confirmationScreen');
					}else if(response.pwdExists){
						dispatch(notification("Your new password should be different from the current password."));
					}else{
						dispatch(notification(errorMessage.tryAgain))
					}
				}) 
			}
			dispatch(hideLoader())
		})
	  }
  }
	/* 	Name : Neha Agrawal
		Description : Function is used to fetch user details.
	*/
	export function getUserDetails()
	{
		return function(dispatch) {
			dispatch(showLoader())
			return getUserData()
			.then(json => {
				dispatch(actions.change("userDetails",{...json,opt_out_email: json.opt_out_email=='1' ? true:false}))
				dispatch(hideLoader())
			})
		}
	}
	/* Name : Neha Agrawal
	 Description : Function is used to update the user details along with the password.
	*/
	export function updateUserDetails(validateSchema,passwordSchema)
	{
		return (dispatch,getState) => {
			let {userDetails} = getState()
			validateAndCheckErrors(dispatch,validateSchema,userDetails).then(flag=>{
				if(flag)
				{
					if((userDetails.current_password && userDetails.current_password!='')  || ( userDetails.new_password && userDetails.new_password!='')  || (userDetails.cnf_password && userDetails.cnf_password!=''))
					{
						validateAndCheckErrors(dispatch,passwordSchema,userDetails).then(flag=>{
							if(userDetails.current_password!='' && userDetails.new_password!='' && userDetails.current_password==userDetails.new_password)
							{
								dispatch(notification("Your new password should be different from the current password."));
								flag=false;
							}
							if(flag)
							{
								//console.log(userDetails.barno);
								if((userDetails.user_type=='1' || userDetails.user_type=='0') && (userDetails.barno.trim()=='' || userDetails.barno==undefined))
								{
									let message = (userDetails.user_type=='1') ? 'Please enter your bar number.' : 'Please enter your badge number.';
									dispatch(notification(message));
									}else{
									dispatch(showLoader())
									return updateUserData(userDetails).then(response => {
										dispatch(hideLoader())
										if(response.status=='1')
										{
											dispatch(notification("User Information updated successfully."));
											dispatch(hideShowPassword(false))
											dispatch(resetModalValues("userDetails.current_password"))
											dispatch(resetModalValues("userDetails.new_password"))
											dispatch(resetModalValues("userDetails.cnf_password"))
										}
										if(response.incorrectPassword=='1')
										{
											dispatch(notification("The password you entered doesn't match what we have on file."));
										}
									})
								}
							}
						})
					}else{
						if((userDetails.user_type=='1' || userDetails.user_type=='0') && (userDetails.barno.trim()=='' || userDetails.barno==undefined))
						{
							let message = (userDetails.user_type=='1') ? 'Please enter your bar number.' : 'Please enter your badge number.';
							dispatch(notification(message));
							}else{
								dispatch(showLoader())
								return updateUserData(userDetails).then(response => {
								dispatch(hideLoader())
								if(response.status=='1')
								{
									dispatch(notification("User Information updated successfully."));
									dispatch(hideShowPassword(false))
								}
							})
						}
					}
				}
			})
				
		}
	}